module.exports = __webpack_public_path__ + "static/img/12.7800637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/zh/12.png
// module id = QAv+
// module chunks = 0